<template>
  <div class="container">
    <!--loading动画-->
    <div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;left:0;background:#000000;z-index:10000;opacity:0.8;">
        <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
          <img src="/static/images/loading.gif" width="150"/>
        </div>
      </div>

    <div class="page-content ar-detail">
      <div class="media-cont">
        <div class="media-cont-logo">
          <img src="../../static/images/head-a.png">
        </div>
        <div class="detail-logo">
          <img src="../../static/images/logo.gif">
        </div>
      </div>
      <div class="detail">
      <!--<div class="detail-no">-->
        <div class="media-cont-title">
          {{ articleInfo.title }}
          <div class="media-meta-list">
            <span class="media-meta-day">{{ addtime }}</span>
          </div>
        </div>

        <!-- 文章主体 -->
        {{{ articleInfo.content }}}

        <br />
        <p  class="font-weight blue">大家都在用IBDATA，你不用就亏了。想叱咤资本市场，想笑看起起落落，想机会尽在掌握，来IBDATA就对了。</p>
        <span class="detail-img ">
          <img src="../../static/images/bottom-code.png">
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import {apiUrl, alert} from '../helper'
  import $ from 'jquery'

  export default {
    name: 'NewArticle',
    data () {
      return {
        name: '',
        id: {},
        articleInfo: {},
        addtime: ''
      }
    },
    route: {
      data ({ to }) {
        this.id.id = to.params.id
        $.ajax({
          url: apiUrl('/V1.0.0/article/detail'),
          method: 'post',
          data: JSON.stringify(this.id),
          dataType: 'json'
        }).done((response) => {
          if (response.status === 0) {
            this.articleInfo = response.data
            let addtime = response.data.addtime.split('T')[0]
            this.addtime = addtime;
            this.changeMetaTitle(response.data.title);
          } else {
            console.log(response.description)
          }
        }).fail((response) => {
          alert('请求失败')
          console.log(response.status)
        })
      }
    },
    methods: {
      changeMetaTitle (title) {
        document.title = title
      },
    }
  }
</script>

<style scoped>
  @import "../../static/css/article.css";

  .ar-detail p {
    font-size: 14px;
    line-height: 28px;
    color: #383838;
  }

  .ar-detail .blue {
    color: #3270ad !important;
  }
</style>



/** WEBPACK FOOTER **
 ** ArticleDetail.vue?5414e394
 **/